import { integrationApi } from "@repo/api";
import { useQuery } from "@tanstack/react-query";

export const useFeatureResourceTypes = (
  featureName: string,
  options?: Record<string, unknown>,
) => {
  return useQuery({
    queryKey: ["featureResourceTypes", featureName],
    queryFn: () => integrationApi.getFeatureResourceTypes(featureName),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
